import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import {
  getTrackerConnection,
  getTrackerProviders,
  getTrackerStatus,
  type TrackerConnection,
  type TrackerProvider,
  type TrackerStatus,
} from "./taskTrackerApi";

// Хуки секции «Трекер задач» (ADR-0075). Org-scoped запросы (см.
// `src/query/scope.ts`), `retry: false` — на 401/403/502 повторяем по
// кнопке, не сами.

/** Смысловая часть ключа кэша подключения (без скоуп-сегмента). */
export const TRACKER_CONNECTION_KEY = [
  "connections",
  "task-tracker",
  "connection",
] as const;

/** Смысловая часть ключа кэша живого статуса (без скоуп-сегмента). */
export const TRACKER_STATUS_KEY = [
  "connections",
  "task-tracker",
  "status",
] as const;

export function useTrackerProviders(): UseQueryResult<
  readonly TrackerProvider[],
  Error
> {
  return useOrgScopedQuery<readonly TrackerProvider[]>({
    key: ["connections", "task-tracker", "providers"],
    queryFn: () => getTrackerProviders(),
    retry: false,
  });
}

export function useTrackerConnection(): UseQueryResult<
  TrackerConnection,
  Error
> {
  return useOrgScopedQuery<TrackerConnection>({
    key: TRACKER_CONNECTION_KEY,
    queryFn: () => getTrackerConnection(),
    retry: false,
  });
}

/**
 * Живой отчёт о доступности. Включается только при `connected`: без
 * сохранённого подключения трекеру нечем пробовать.
 */
export function useTrackerStatus(
  enabled: boolean,
): UseQueryResult<TrackerStatus, Error> {
  return useOrgScopedQuery<TrackerStatus>({
    key: TRACKER_STATUS_KEY,
    queryFn: () => getTrackerStatus(),
    retry: false,
    enabled,
  });
}
